module.exports = __webpack_public_path__ + "img/bannerProjets.b80a177e.jpg";